import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link, NavLink, Outlet } from 'react-router-dom';
import { BRAND_NAME } from '../routes';
import { TEST_IDS } from '../utils/testIds';
const NAV_ITEMS = [
    {
        to: '/admin',
        label: 'Dashboard',
        end: true,
        testId: undefined
    },
    {
        to: '/admin/products',
        label: 'Products',
        end: false,
        testId: TEST_IDS.adminNavProducts
    },
    {
        to: '/admin/orders',
        label: 'Orders',
        end: false,
        testId: TEST_IDS.adminNavOrders
    },
    {
        to: '/admin/wholesalers',
        label: 'Wholesalers',
        end: false,
        testId: TEST_IDS.adminNavWholesalers
    }
];
export default function AdminLayout() {
    return /*#__PURE__*/ _jsxs("div", {
        className: "min-h-screen flex flex-col",
        children: [
            /*#__PURE__*/ _jsx("header", {
                className: "bg-stone-900 text-white px-4 py-3 flex items-center justify-between",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "flex items-center gap-4",
                    children: [
                        /*#__PURE__*/ _jsx(Link, {
                            to: "/",
                            className: "text-sm text-stone-300 hover:text-white",
                            children: "← Back to store"
                        }),
                        /*#__PURE__*/ _jsx("span", {
                            className: "text-sm text-stone-500",
                            children: "|"
                        }),
                        /*#__PURE__*/ _jsxs("span", {
                            className: "font-semibold text-sm",
                            children: [
                                BRAND_NAME,
                                " — Admin"
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex flex-1",
                children: [
                    /*#__PURE__*/ _jsx("nav", {
                        className: "w-48 bg-stone-950 text-stone-300 py-4 flex-shrink-0",
                        children: /*#__PURE__*/ _jsx("ul", {
                            className: "space-y-1 px-2",
                            children: NAV_ITEMS.map((item)=>/*#__PURE__*/ _jsx("li", {
                                    children: /*#__PURE__*/ _jsx(NavLink, {
                                        to: item.to,
                                        end: item.end,
                                        "data-testid": item.testId,
                                        className: ({ isActive })=>`block px-3 py-2 text-sm font-medium transition-colors ${isActive ? 'bg-stone-800 text-white' : 'hover:bg-stone-800/50 hover:text-white'}`,
                                        children: item.label
                                    })
                                }, item.to))
                        })
                    }),
                    /*#__PURE__*/ _jsx("main", {
                        className: "flex-1 bg-stone-50 overflow-y-auto",
                        children: /*#__PURE__*/ _jsx(Outlet, {})
                    })
                ]
            })
        ]
    });
}
